var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMobileSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_pc_small",
    transform: "translate(-700 -201)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2932",
    "data-name": "Rectangle 2932",
    width: 24,
    height: 24,
    transform: "translate(700 201)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3013",
    "data-name": "Rectangle 3013",
    transform: "translate(705 204)",
    fill: "none",
    stroke: "#555bf0",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 18,
    rx: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 12,
    height: 16,
    rx: 2,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6710",
    "data-name": "Path 6710",
    d: "M708.839,196.9h3.308",
    transform: "translate(1.459 11.315)",
    fill: "none",
    stroke: "#555bf0",
    strokeLinecap: "round",
    strokeWidth: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMobileSmall);
export default __webpack_public_path__ + "static/media/icon_mobile_small.30535405.svg";
export { ForwardRef as ReactComponent };